import LegalPage from "./LegalPage";

export default function Privacy() {
  return <LegalPage contentKey="privacy" testId="privacy-page" />;
}
